import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import Banner from '../../components/Banner'
import { IoCall, IoLocationSharp, IoMail } from 'react-icons/io5'
import { Link } from 'react-router-dom'

function ContactUs() {
    return (
        <div className='contact-us-page'>
            <Banner title={"Contact Us"} image={require('../../assets/images/gallery.png')} />
            <Container className='py-5'>
                <Row className='gy-4'>
                    <Col className="col-12 col-md-6">
                        <div className='border-rad-20 bg-secondBgColor overflow-hidden'>
                            <div className='flex-center-align'>
                                <div className='w-100 fw-bold text-uppercase no-border-rad text-center py-4 custom-bg-temp color-secondBgColor fs-18'>Send Enquiry</div>
                            </div>
                            <div className='p-3 p-md-4 p-xl-5 d-grid'>
                                <form>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input type="text" className="form-control" id="name" placeholder="Enter your name" required />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" className="form-control" id="email" placeholder="Enter your email" required />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <input type="tel" className="form-control" id="phone" placeholder="Enter your phone number" required />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="message" className="form-label">Message</label>
                                        <textarea className="form-control" id="message" rows={4} placeholder="Enter your message" required defaultValue={""} />
                                    </div>
                                    <Button type="submit" variant='success' className="custom-bg-temp fw-semibold w-100">Submit</Button>
                                </form>
                            </div>
                        </div>
                    </Col>
                    <Col className='col-12 col-md-6 d-grid align-content-between gap-2'>
                        <div className='bg-secondBgColor border-rad-20 overflow-hidden d-flex p-4 gap-4'>
                            <div className='d-grid align-content-start'>
                                <Link className='flex-center-align icon-part' to={"tel:919979145600"}>
                                    <IoCall className='fs-35' />
                                </Link>
                            </div>
                            <div className='d-grid align-content-center gap-1 content-part'>
                                <Link className='fs-18 fw-bold' to={"tel:919979145600"}>Phone</Link>
                                <Link className='fw-light' to={"tel:919979145600"}>+91 99791 45600</Link>
                            </div>
                        </div>
                        <div className='bg-secondBgColor border-rad-20 overflow-hidden d-flex p-4 gap-4'>
                            <div className='d-grid align-content-start'>
                                <Link className='flex-center-align icon-part' to={"mailto:info@nexuspaperpacks.com"}>
                                    <IoMail className='fs-35' />
                                </Link>
                            </div>
                            <div className='d-grid align-content-center gap-1 content-part'>
                                <Link className='fs-18 fw-bold' to={"mailto:info@nexuspaperpacks.com"}>FOR DOMESTIC & GENERAL INQUIRIES</Link>
                                <Link className='fw-light' to={"mailto:info@nexuspaperpacks.com"}>info@nexuspaperpacks.com</Link>
                            </div>
                        </div>
                        <div className='bg-secondBgColor border-rad-20 overflow-hidden d-flex p-4 gap-4'>
                            <div className='d-grid align-content-start'>
                                <Link className='flex-center-align icon-part' to={"mailto:rahul@nexuspaperpacks.com"}>
                                    <IoMail className='fs-35' />
                                </Link>
                            </div>
                            <div className='d-grid align-content-center gap-1 content-part'>
                                <Link className='fs-18 fw-bold' to={"mailto:rahul@nexuspaperpacks.com"}>FOR EXPORTS</Link>
                                <Link className='fw-light' to={"mailto:rahul@nexuspaperpacks.com"}>rahul@nexuspaperpacks.com </Link>
                            </div>
                        </div>
                        <div className='bg-secondBgColor border-rad-20 overflow-hidden d-flex p-4 gap-4'>
                            <div className='d-grid align-content-start'>
                                <Link className='flex-center-align icon-part'>
                                    <IoLocationSharp className='fs-35' />
                                </Link>
                            </div>
                            <div className='d-grid align-content-center gap-1 content-part'>
                                <Link className='fs-18 fw-bold'>Plant Address</Link>
                                <Link className='fw-light fs-14 text-uppercase'>Om industry, Makna, Kadodara Highway, surat, Gujarat</Link>
                            </div>
                        </div>
                        <div className='bg-secondBgColor border-rad-20 overflow-hidden d-flex p-4 gap-4'>
                            <div className='d-grid align-content-start'>
                                <Link className='flex-center-align icon-part'>
                                    <IoLocationSharp className='fs-35' />
                                </Link>
                            </div>
                            <div className='d-grid align-content-center gap-1 content-part'>
                                <Link className='fs-18 fw-bold'>Head Office Address</Link>
                                <Link className='fw-light fs-14 text-uppercase'>3A, 4th Floor, Dolphin House, Nr. Tapi Baug Society, Mini Bazar, Varachha Main Road, Surat-395006</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ContactUs